module.exports = __webpack_public_path__ + "img/close-icon.d22207b3.svg";